import type { SubscriptionTrialUsageSelectFragment } from '~/modules/pricing/graphql/fragments/subscriptionTrialUsage.generated';

export enum IShopPlanState {
  TRIAL_PAGE_OPT = 'TRIAL_PAGE_OPT',
  TRIAL_FUNNEL_OPT = 'TRIAL_FUNNEL_OPT',
  TRIAL_PROFIT_OPT = 'TRIAL_PROFIT_OPT',
  ACTIVE_PAGE_OPT = 'ACTIVE_PAGE_OPT',
  ACTIVE_FUNNEL_OPT = 'ACTIVE_FUNNEL_OPT',
  ACTIVE_PROFIT_OPT = 'ACTIVE_PROFIT_OPT',

  LOADING_PLAN = 'LOADING_PLAN',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',

  ACTIVE_PAGE_OPT_AND_TRIAL_PAGE_OPT = 'ACTIVE_PAGE_OPT_AND_TRIAL_PAGE_OPT',
  ACTIVE_PAGE_OPT_AND_TRIAL_FUNNEL_OPT = 'ACTIVE_PAGE_OPT_AND_TRIAL_FUNNEL_OPT',
  ACTIVE_FUNNEL_OPT_AND_TRIAL_FUNNEL_OPT = 'ACTIVE_FUNNEL_OPT_AND_TRIAL_FUNNEL_OPT',
}

export enum IPricingModal {
  PRICING = 'PRICING',
  UNINSTALL = 'UNINSTALL',
  CANCEL_PLAN = 'CANCEL_PLAN',
  DOWNGRADE_PLAN = 'DOWNGRADE_PLAN',
  REVIEW_PLAN = 'REVIEW_PLAN',
  NONE = 'NONE',
}

export type ISubscriptionTrialUsage = SubscriptionTrialUsageSelectFragment;
